// frontend/apps/widgets/src/widgets/common/components/WidgetErrorBoundary.js
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography, Button} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false, error: null};
  }

  static getDerivedStateFromError(error) {
    return {hasError: true, error};
  }

  componentDidCatch(error, errorInfo) {
    // Log error without sensitive information
    console.error('[Widget Error]:', {
      message: error.message,
      component: this.props.widgetType,
      timestamp: new Date().toISOString(),
    });
  }

  handleRetry = () => {
    this.setState({hasError: false, error: null});
    if (this.props.onRetry) {
      this.props.onRetry();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 400,
          p: 3,
          textAlign: 'center',
        }}>
          <ErrorOutlineIcon sx={{fontSize: 48, color: 'error.main', mb: 2}} />
          <Typography variant="h6" gutterBottom>
            Une erreur est survenue
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{mb: 3}}>
            Le widget n&apos;a pas pu se charger correctement.
          </Typography>
          <Button variant="outlined" onClick={this.handleRetry} size="small">
            Réessayer
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

WidgetErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  widgetType: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
};

export default WidgetErrorBoundary;
